/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  SettingOutlined,
  CloseOutlined,
  SaveOutlined,
} from "@ant-design/icons";

import Fixer from "./fixer";
import { header } from "../../../../../../components/api/Header";
import { getEnv } from "../../../../../../lib/env";

const hcols = [
  0, 2, 2, 2, 2, 1, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 3,
  2, 2, 2, 2,
];
const bcols = Array(55).fill(1);

function Table({ date }) {
  const [c, setC] = useState(hcols);
  const [bc, setBc] = useState(bcols);
  const [data, setData] = useState([]);
  const [menu, setMenu] = useState(false);
  const [loading, setLoading] = useState(false);

  const saveHandler = async () => {
    const res = await axios
      .post(
        getEnv('REACT_APP_BASE_URL') + "/v1/region/sugorish/savecontrol",
        { c, bolim: "vegetatsiya", bc },
        header()
      )
      .catch((e) => {
        console.log("Xato", e);
        alert("Serverga bog'lanishda xato");
      });
    if (res) {
      if (res.data.length > 1) {
        setC(res.data);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [res, res2] = await Promise.all([
          axios.get(
            `${getEnv('REACT_APP_BASE_URL')}/v1/region/sugorish/vegetatsiya?date=${date}`,
            header()
          ),
          axios.get(
            `${getEnv('REACT_APP_BASE_URL')}/v1/republik/sugorish/vegetatsiya?date=${date}`,
            header()
          ),
        ]);

        const regionData = res.data || {};
        setData(regionData.data || []);

        if (
          Array.isArray(regionData.controls) &&
          regionData.controls.length > 1
        ) {
          setC(regionData.controls);
        }

        if (Array.isArray(regionData.bodyc) && regionData.bodyc.length > 1) {
          setBc(regionData.bodyc);
        } else if (res2.data?.bodyc) {
          setBc(res2.data.bodyc);
        }
      } catch (e) {
        console.log("Xato", e);
        alert("Serverga bog'lanishda xato");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [date]);

  return (
    <div className='table-responsive tableFixHead controllable-table-block'>
      {menu ? (
        <div className='table-controls-close active d-flex justify-content-between'>
          <button
            className='btn btn-sm btn-outline-primary d-flex align-items-center'
            onClick={() => saveHandler()}>
            Saqlash &nbsp;&nbsp;
            <SaveOutlined />
          </button>

          <CloseOutlined
            className='btn btn-secondary btn-sm'
            onClick={() => setMenu(false)}
          />
        </div>
      ) : (
        <div className='table-controls-open active'>
          <SettingOutlined
            className='btn btn-secondary'
            onClick={() => setMenu(true)}
          />
        </div>
      )}

      <div
        className={menu ? "table-controls-menu active" : "table-controls-menu"}>
        <Fixer c={c} setC={setC} bc={bc} setBc={setBc} date={date} />
      </div>

      <table className='table table-bordered table-style' id='controllable'>
        <thead>
          <tr>
            <th rowSpan='6'>Hududlar nomi</th>

            <th
              colSpan={c[1] + c[2]}
              className={c[1] + c[2] == 0 ? "hidden" : ""}>
              Sug‘orish ishlariga olingan suv miqdori
            </th>

            <th
              colSpan={sum(
                c,
                [
                  3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                  20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
                ]
              )}
              className={
                sum(
                  c,
                  [
                    3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                    20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
                  ]
                ) == 0
                  ? "hidden"
                  : ""
              }>
              Sug‘orilgan maydon, ming ga
            </th>

            <th rowSpan='6'>Sug‘orish ishlarida qatnashgan suvchilar soni</th>
          </tr>

          <tr>
            <th
              colSpan={c[1]}
              rowSpan='2'
              className={c[1] == 0 ? "hidden" : ""}>
              1.04-{date} y. mln.m3
            </th>

            <th
              colSpan={c[2]}
              rowSpan='2'
              className={c[2] == 0 ? "hidden" : ""}>
              Kunlik suv sarfi m3/s.
            </th>

            <th
              colSpan={c[3]}
              rowSpan='2'
              className={c[3] == 0 ? "hidden" : ""}>
              Jami sug‘orish ishlari
            </th>

            <th
              colSpan={sum(
                c,
                [
                  4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
                  21, 22, 23, 24, 25, 26,
                ]
              )}
              className={
                sum(
                  c,
                  [
                    4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                    20, 21, 22, 23, 24, 25, 26,
                  ]
                ) == 0
                  ? "hidden"
                  : ""
              }>
              shundan
            </th>

            <th
              colSpan={c[27]}
              rowSpan='2'
              className={c[27] == 0 ? "hidden" : ""}>
              G‘alla ekishdan oldingi nam suvi berish
            </th>

            <th
              colSpan={c[28] + c[29]}
              className={c[28] + c[29] == 0 ? "hidden" : ""}>
              shu jumladan
            </th>
          </tr>

          <tr>
            <th
              colSpan={c[4]}
              style={{ minWidth: "152px" }}
              className={c[4] == 0 ? "hidden" : ""}>
              G‘alla ekishdan oldingi sho‘r yuvish va nam suvi berish
            </th>

            <th
              colSpan={sum(c, [5, 6, 7, 8, 9, 10, 11, 12, 13])}
              className={
                sum(c, [5, 6, 7, 8, 9, 10, 11, 12, 13]) == 0 ? "hidden" : ""
              }>
              G‘alla sug‘orish
            </th>

            <th
              colSpan={sum(c, [14, 15, 16, 17, 18, 19, 20, 21, 22, 23])}
              className={
                sum(c, [14, 15, 16, 17, 18, 19, 20, 21, 22, 23]) == 0
                  ? "hidden"
                  : ""
              }>
              G‘o‘za sug‘orish
            </th>

            <th colSpan={c[24]} className={c[24] == 0 ? "hidden" : ""}>
              Takroriy ekin sug‘orish
            </th>

            <th colSpan={c[25]} className={c[25] == 0 ? "hidden" : ""}>
              Pushta va nam suvi berish ishlari
            </th>

            <th colSpan={c[26]} className={c[26] == 0 ? "hidden" : ""}>
              Tomorqa va boshqa sug‘orish ishlari
            </th>

            <th colSpan={c[28]} className={c[28] == 0 ? "hidden" : ""}>
              ochiq maydon
            </th>

            <th colSpan={c[29]} className={c[29] == 0 ? "hidden" : ""}>
              g‘o‘za qator orasi
            </th>
          </tr>

          <tr>
            <th rowSpan='3' className={c[1] == 0 ? "hidden" : ""}>
              limit
            </th>

            <th rowSpan='3' className={c[1] == 0 ? "hidden" : ""}>
              amalda
            </th>

            <th rowSpan='3' className={c[2] == 0 ? "hidden" : ""}>
              limit
            </th>

            <th rowSpan='3' className={c[2] == 0 ? "hidden" : ""}>
              amalda
            </th>

            <th rowSpan='3' className={c[3] == 0 ? "hidden" : ""}>
              1 kunda
            </th>

            <th rowSpan='3' className={c[3] == 0 ? "hidden" : ""}>
              jami
            </th>

            <th rowSpan='3' className={c[4] == 0 ? "hidden" : ""}>
              1 kunda
            </th>

            <th rowSpan='3' className={c[4] == 0 ? "hidden" : ""}>
              Jami
            </th>

            <th rowSpan='3' className={c[5] == 0 ? "hidden" : ""}>
              Reja
            </th>

            <th rowSpan='3' className={c[6] == 0 ? "hidden" : ""}>
              1 kunda
            </th>

            <th rowSpan='3' className={c[7] == 0 ? "hidden" : ""}>
              jami ekilgandan boshlab
            </th>

            <th
              colSpan={sum(c, [8, 9, 10, 11, 12, 13])}
              className={sum(c, [8, 9, 10, 11, 12, 13]) == 0 ? "hidden" : ""}>
              shu jumladan
            </th>

            <th rowSpan='3' className={c[14] == 0 ? "hidden" : ""}>
              Reja
            </th>

            <th rowSpan='3' className={c[15] == 0 ? "hidden" : ""}>
              1 kunda
            </th>

            <th rowSpan='3' className={c[16] == 0 ? "hidden" : ""}>
              Jami
            </th>

            <th
              colSpan={sum(c, [17, 18, 19, 20, 21, 22, 23])}
              className={
                sum(c, [17, 18, 19, 20, 21, 22, 23]) == 0 ? "hidden" : ""
              }>
              shundan
            </th>

            <th rowSpan='3' className={c[24] == 0 ? "hidden" : ""}>
              1 kunda
            </th>

            <th rowSpan='3' className={c[24] == 0 ? "hidden" : ""}>
              Jami
            </th>

            <th rowSpan='3' className={c[25] == 0 ? "hidden" : ""}>
              Reja
            </th>

            <th rowSpan='3' className={c[25] == 0 ? "hidden" : ""}>
              1 kunda
            </th>

            <th rowSpan='3' className={c[25] == 0 ? "hidden" : ""}>
              jami
            </th>

            <th rowSpan='3' className={c[26] == 0 ? "hidden" : ""}>
              1 kunda
            </th>

            <th rowSpan='3' className={c[26] == 0 ? "hidden" : ""}>
              jami
            </th>

            <th rowSpan='3' className={c[27] == 0 ? "hidden" : ""}>
              1 kunda
            </th>

            <th rowSpan='3' className={c[27] == 0 ? "hidden" : ""}>
              Jami
            </th>

            <th rowSpan='3' className={c[28] == 0 ? "hidden" : ""}>
              1 kunda
            </th>

            <th rowSpan='3' className={c[28] == 0 ? "hidden" : ""}>
              Jami
            </th>

            <th rowSpan='3' className={c[29] == 0 ? "hidden" : ""}>
              1 kunda
            </th>

            <th rowSpan='3' className={c[29] == 0 ? "hidden" : ""}>
              Jami
            </th>
          </tr>

          <tr>
            <th colSpan={c[8]} className={c[8] == 0 ? "hidden" : ""}>
              1-suv
            </th>

            <th colSpan={c[9]} className={c[9] == 0 ? "hidden" : ""}>
              2-suv
            </th>

            <th colSpan={c[10]} className={c[10] == 0 ? "hidden" : ""}>
              3-suv
            </th>

            <th colSpan={c[11]} className={c[11] == 0 ? "hidden" : ""}>
              4-suv
            </th>

            <th colSpan={c[12]} className={c[12] == 0 ? "hidden" : ""}>
              5-suv
            </th>

            <th colSpan={c[13]} className={c[13] == 0 ? "hidden" : ""}>
              6-suv
            </th>

            <th colSpan={c[17]} className={c[17] == 0 ? "hidden" : ""}>
              1-suv
            </th>

            <th colSpan={c[18]} className={c[18] == 0 ? "hidden" : ""}>
              2-suv
            </th>

            <th colSpan={c[19]} className={c[19] == 0 ? "hidden" : ""}>
              3-suv
            </th>

            <th colSpan={c[20]} className={c[20] == 0 ? "hidden" : ""}>
              4-suv
            </th>

            <th colSpan={c[21]} className={c[21] == 0 ? "hidden" : ""}>
              5-сув
            </th>

            <th colSpan={c[22]} className={c[22] == 0 ? "hidden" : ""}>
              6-suv
            </th>

            <th colSpan={c[23]} className={c[23] == 0 ? "hidden" : ""}>
              7-suv
            </th>
          </tr>

          <tr>
            <th className={c[8] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[8] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[9] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[9] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[10] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[10] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[11] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[11] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[12] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[12] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[13] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[13] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[17] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[17] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[18] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[18] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[19] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[19] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[20] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[20] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[21] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[21] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[22] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[22] == 0 ? "hidden" : ""}>jami</th>
            <th className={c[23] == 0 ? "hidden" : ""}>1 kunda</th>
            <th className={c[23] == 0 ? "hidden" : ""}>jami</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            {Array(55)
              .fill()
              .map((_, i) => {
                return (
                  <td key={i} className={bc[i] == 0 ? "hidden" : ""}>
                    {i}
                  </td>
                );
              })}
          </tr>
        </tbody>

        {data
          ? data.map((d, i) => {
              return (
                <tbody key={i}>
                  <tr>
                    <td>{d.name}</td>
                  </tr>
                </tbody>
              );
            })
          : null}
      </table>
    </div>
  );
}

// shu joydan davom etasan

export default Table;

const sum = (d, a) => {
  let s = 0;
  a.map((i) => (s += d[i]));
  return s;
};
